import useUserAuthOry from "../composables/useUserAuthOry.mjs";
import useUserAuth from "../composables/useUserAuth.mjs";
import { useRemApi } from "../composables/useRem.mjs";
import { isLinkRecoveryMethod } from "../composables/useUtils.mjs";
import { useSessionOry } from "../composables/useSessionOry.mjs";
import { defineNuxtRouteMiddleware, useRuntimeConfig, navigateTo } from "#imports";
const pathsToCheck = ["login", "recovery", "verification", "failed"];
const whiteList = (path) => {
  return pathsToCheck.some((p) => path.includes(p));
};
export default defineNuxtRouteMiddleware(async (to, from) => {
  const config = useRuntimeConfig();
  const urlAbsolute = config.public?.sharedSelfService?.apiUrl?.replace("/api", "");
  try {
    if (whiteList(to.path)) {
      return;
    }
    const { setUserAuthOryData } = useUserAuthOry();
    const sessionData = await useSessionOry();
    setUserAuthOryData(sessionData);
    if (!sessionData && (!whiteList(to.name) && !to.path.includes("login"))) {
      return navigateTo(config.public?.sharedSelfService?.redirectUrlToLogin, { external: true });
    }
    if (isLinkRecoveryMethod(sessionData) && !to.path.includes("password")) {
      return navigateTo(config.public?.sharedSelfService?.redirectUrlToChangePassword, { external: true });
    }
    const { setUserAuthData } = useUserAuth();
    const { data } = await useRemApi(`${urlAbsolute}/users/me`);
    setUserAuthData(data.value);
  } catch (error) {
    if (!whiteList(to.name) && !to.path.includes("login") && process.env.NODE_ENV !== "development") {
      return navigateTo(config.public?.sharedSelfService?.redirectUrlToLogin, { external: true });
    }
  }
});
